import { createRouter, createWebHashHistory, Router, RouteRecordRaw } from 'vue-router';

let _router = null as null | Router;
export function getRouter(routes?: RouteRecordRaw[]) {
  if (_router) {
    return _router;
  }
  if (!routes) {
    throw new Error('没有提供必须的routes参数！');
  }
  _router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
      return new Promise((resolve) => {
        if (savedPosition) {
          return savedPosition;
        }
        if (from.meta.saveScrollTop) {
          const top: number = document.documentElement.scrollTop || document.body.scrollTop;
          resolve({ left: 0, top });
        }
      });
    },
  });

  return _router;
}
